module.exports = __webpack_public_path__ + "img/15.258f7c96.jpg";